if (!customElements.get('custom-tabs')) {
  customElements.define(
    'custom-tabs',
    class CustomTabs extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.section-stack__tabs button').forEach((button) => {
          button.addEventListener('click', () => {
            this.changeTab(button);
          });
        });

        const activeButton = [...this.querySelectorAll('.section-stack__tabs button')].find((button) => button.dataset.active === 'true');

        if (activeButton) {
          this.changeTab(activeButton);
        }
      }

      changeTab(activeButton) {
        const target = activeButton.dataset.toggle;

        this.querySelectorAll('.section-stack__tabs button').forEach((button) => {
          button.dataset.active = button === activeButton;
        });

        this.querySelectorAll('[data-toggle]').forEach((tab) => {
          if (tab.matches('button')) return;

          tab.classList.toggle('tab-hidden', tab.dataset.toggle !== target);
        });
      }
    },
  );
}
